import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { OutreachReplyLabel } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { PanelHead } from '../../components/primitives/Panel';
import { useReplyThread } from '../hooks/useReplyThread';
import { useOutreachPlan } from '../hooks/useOutreachPlan';
import type { ReplyThread } from '../outreachTypes';
import { replyTitle } from '../outreachFormat';
import { REPLY_LABELS, REPLY_LABEL_TEXT } from './replyLabels';
import { inboxMessages as messages } from './inboxMessages';

/** The head of a thread (design outreach g1): who, the address and the song, and the label to change. */
const ThreadHeaderComponent: React.FC<{ accountId: number; thread: ReplyThread }> = ({ accountId, thread }) => {
  const intl = useIntl();
  const { isDemo } = useOutreachPlan();
  const { setLabel } = useReplyThread(accountId, thread.replyUuid);
  const options = useMemo(
    () =>
      REPLY_LABELS.map((label) => (
        <option key={label} value={label}>
          {intl.formatMessage(REPLY_LABEL_TEXT[label])}
        </option>
      )),
    [intl]
  );
  return (
    <PanelHead
      title={replyTitle(thread.contactName, thread.targetName)}
      subtitle={`${thread.fromEmail} · ${thread.songTitle}`}
      right={
        <select
          className="form-select form-select-sm w-auto"
          aria-label={intl.formatMessage(messages.changeLabel)}
          value={thread.label}
          disabled={isDemo}
          onChange={(event) =>
            setLabel({ replyUuid: thread.replyUuid, label: event.target.value as OutreachReplyLabel }).catch(
              console.error
            )
          }
        >
          {options}
        </select>
      }
    />
  );
};

export const ThreadHeader = TypedMemo(ThreadHeaderComponent);
